import { Component, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { MdDialog, MdDialogRef } from '@angular/material';
import { MessageBoxDialog } from '../message-box/message-box.component';

import {MdMenuModule} from '@angular/material';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { Ng2DeviceService } from 'ng2-device-detector';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  showDrp:boolean = false;
  username: string;
  company_name: string;
  role: string;
  user_acronym: string;
  notifications: number;
  deviceInfo = null;
  chrome_version = "56.0.2924";
  safari_version = "10.0.3";
  explorer_version = "10.0";
  firefox_version = "45.7.0esr";

  isIn = false;   // store state
  toggleState() { // click handler
      let bool = this.isIn;
      this.isIn = bool === false ? true : false;
  }

  premium:string;
  user_search:string;
  company_status: number;
  noBrowserSupported: string;
  browser_version: string;

  errorConnection: boolean;
  
  event: EventEmitter<String> = new EventEmitter<String>();

  constructor(
    private router: Router,
    private auth: AuthService,
    private notificationService: NotificationService,
    private dialog: MdDialog,
    private deviceService: Ng2DeviceService,
    private configurationService: ConfigurationService
  ) { 
    this.getNotifications();
    setInterval(() => this.getNotifications(), 100000);
  }

  ngOnInit() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    if (this.deviceInfo.browser === 'chrome') {
      this.browser_version = this.chrome_version;
    } else if (this.deviceInfo.browser === 'safari') {
      this.browser_version = this.safari_version;
    } else if (this.deviceInfo.browser === 'ie') {
      this.browser_version = this.explorer_version;
    } else if (this.deviceInfo.browser === 'firefox') {
      this.browser_version = this.firefox_version;
    } else {
      this.browser_version = '';
    }

    if (this.browser_version !== '') {
      const options = {lexicographical: true, zeroExtend: true};
      const compare = this.versionCompare(this.deviceInfo.browser_version, this.browser_version, options);
      if (compare < 0) {
        this.noBrowserSupported = 'true';
      } else {
        this.noBrowserSupported = 'false';
      }
    } else {
      this.noBrowserSupported = 'true';
    }

    this.configurationService.configuration$.subscribe(
      response => {
        if (response) {
          this.refreshConfiguration();
        } else {
          this.company_status = -1;
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );

    this.configurationService.errorHttp$.subscribe(
      response => {
        if (response) {
          this.errorConnection = true;
        } else {
          this.errorConnection = false;
        }
        // this.dialog.open(MessageBoxDialog, {data: {message: "No se pudo conectar con el servidor, Problemas de conexión con internet", success:true, showIcon:true}});
      }
    );
    this.refreshConfiguration();
  }

  refreshConfiguration() {
    if (localStorage.getItem('name') ){
      this.username = localStorage.getItem('name');
      this.user_acronym = localStorage.getItem('name').substr(0,1);
    } else {
      this.username = '';
      this.user_acronym = '';
    }

    if (localStorage.getItem('status') ){
      this.company_status = Number(localStorage.getItem('status'));
    } else {
      this.company_status = -1;
    }

    if (localStorage.getItem('premium')){
      this.premium = localStorage.getItem('premium');
    } else {
      this.premium = '0';
    }

    if (localStorage.getItem('user_search')){
      this.user_search = localStorage.getItem('user_search');
    } else {
      this.user_search = '0';
    }

    if (localStorage.getItem('role')) {
      this.role = localStorage.getItem('role');
    } else {
      this.role = '';
    }
  }

  getNotifications() {
    if (localStorage.getItem('id_token')) {
      const status = [];
      status.push ('0'); // no leído
      this.notificationService.getNotifications(status)
      .subscribe(
      data => {
        this.notifications = data.pagination.total;
      },
      error => {
        if (error.status == 404) {
          this.notifications = 0;
        } else {
          console.log(error);
          this.notifications = 0;
        }
      });
    }
  }

  onLogout() {
    this.auth.logout();
    this.router.navigate(['login']);
  }

/**
 * Compares two software version numbers (e.g. "1.7.1" or "1.2b").
 *
 * This function was born in http://stackoverflow.com/a/6832721.
 *
 * @param {string} v1 The first version to be compared.
 * @param {string} v2 The second version to be compared.
 * @param {object} [options] Optional flags that affect comparison behavior:
 * <ul>
 *     <li>
 *         <tt>lexicographical: true</tt> compares each part of the version strings lexicographically instead of
 *         naturally; this allows suffixes such as "b" or "dev" but will cause "1.10" to be considered smaller than
 *         "1.2".
 *     </li>
 *     <li>
 *         <tt>zeroExtend: true</tt> changes the result if one version string has less parts than the other. In
 *         this case the shorter string will be padded with "zero" parts instead of being considered smaller.
 *     </li>
 * </ul>
 * @returns {number|NaN}
 * <ul>
 *    <li>0 if the versions are equal</li>
 *    <li>a negative integer iff v1 < v2</li>
 *    <li>a positive integer iff v1 > v2</li>
 *    <li>NaN if either version string is in the wrong format</li>
 * </ul>
 *
 * @copyright by Jon Papaioannou (["john", "papaioannou"].join(".") + "@gmail.com")
 * @license This function is in the public domain. Do what you want with it, no strings attached.
 */
versionCompare(v1, v2, options) {
  let lexicographical = options && options.lexicographical,
      zeroExtend = options && options.zeroExtend,
      v1parts = v1.split('.'),
      v2parts = v2.split('.');

  function isValidPart(x) {
      return (lexicographical ? /^\d+[A-Za-z]*$/ : /^\d+$/).test(x);
  }

  if (!v1parts.every(isValidPart) || !v2parts.every(isValidPart)) {
      return NaN;
  }

  if (zeroExtend) {
      while (v1parts.length < v2parts.length) v1parts.push("0");
      while (v2parts.length < v1parts.length) v2parts.push("0");
  }

  if (!lexicographical) {
      v1parts = v1parts.map(Number);
      v2parts = v2parts.map(Number);
  }

  for (let i = 0; i < v1parts.length; ++i) {
      if (v2parts.length === i) {
        return 1;
      }

      if (Number(v1parts[i]) === Number(v2parts[i])) {
        continue;
      }
      else if (Number(v1parts[i]) > Number(v2parts[i])) {
        return 1;
      }
      else {
        return -1;
      }
  }

  if (v1parts.length != v2parts.length) {
      return -1;
  }

  return 0;
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/menu/menu.component.ts